import { render } from "./buy_one_click.vue?vue&type=template&id=70323ab3&scoped=true"
import script from "./buy_one_click.vue?vue&type=script&lang=js"
export * from "./buy_one_click.vue?vue&type=script&lang=js"

import "./buy_one_click.vue?vue&type=style&index=0&id=70323ab3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70323ab3"]])

export default __exports__